var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group form-group-w-btn"},[_c('label',[_c('input',{ref:"file",attrs:{"type":"file","id":_vm.idInput,"name":_vm.idInput}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }